import React, { useEffect } from 'react'
import Alert from '../../../itrust_common/components/Alert'
import { claimFormCreate } from '../../../redux/actions/order/claimFormActions'
import { orderLoad } from '../../../redux/actions/order/orderActions'
import { connect, useSelector } from 'react-redux'
import { getInsuranceFromRPAServices, isRpaVerifiedInsurance, isRpaVerificationFailed } from '../../../containers/authorised/addOns/other/AddOnsHelperFunctions'
import { visionInsuranceServicesLoad } from '../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceAction'
import { visionInsuranceClaimFormCreate, visionInsuranceClaimFormLoad, visionInsuranceClaimFormEdit } from '../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import { ediClearingHouseServicesLoad } from '../../../redux/actions/addOns/EDIClearingHouse/EdiClearningHouseActions'
import { useHistory } from 'react-router-dom'
import * as $ from 'jquery'
import { groupOrderInsurances, getInsuranceLabel } from './claimFormDropdownUtils'

function ClaimFormDropdownButton(props) {
  const { dispatch, onOpenClaimFormModal, visionInsuranceConfig, services } = props
  const order = useSelector((state) => state.order.order)
  const ordersInsurances = order.orders_insurances_attributes || []
  const currentUserRole = useSelector((state) => state.auth.user?.role)
  const history = useHistory()

  useEffect(() => {
    const storeID = localStorage.getItem('StoreID')
    if (storeID == null) {
      dispatch(visionInsuranceServicesLoad({ store_id: order.store_id, category: 'vision_insurance' }))
      dispatch(ediClearingHouseServicesLoad({ store_id: order.store_id, category: 'edi_clearing_house' }))
    }
  }, [])

  if (order.self_pay || !ordersInsurances.length) {
    return null
  }

  const { visionInsurances, medicalInsurances } = groupOrderInsurances(ordersInsurances)
  const claimFormCount = ordersInsurances.filter(
    (item) => item.claim_form_id || item.visionary_insurance_claim_form_id
  ).length

  const showInsuranceVerificationFailed = (insuranceName) => {
    const rpaVerificationFailed = isRpaVerificationFailed(visionInsuranceConfig, services, insuranceName)
    if (['super_admin', 'itrust_admin'].includes(currentUserRole)) {
      Alert.confirm(
        <div>
          Insurance mapping was unsuccessful:<strong> {rpaVerificationFailed}</strong><br />
          Go to the setting and update the configuration for successful insurance verification.
        </div>,
        (res) => {
          if (res) {
            $('#orderForm-modal').modal('hide')
            history.push('/add-ons/vision-insurance/settings')
          }
        }
      )
    } else {
      Alert.warning(
        <div>
          Insurance mapping was unsuccessful:<strong> {rpaVerificationFailed}</strong><br />
          Please contact you super admin to update the configuration for successful insurance verification.
        </div>
      )
    }
  }

  const openClaimFormModal = (orderInsurance) => {
    onOpenClaimFormModal(orderInsurance)
    setTimeout(() => $(`#claimForm-${order.id}-modal`).modal('show'), 0)
  }

  const refreshOrderInsurance = async (orderInsurance) => {
    const orderRes = await dispatch(orderLoad(order.id, { include: '*' }))
    return orderRes?.value?.data?.order?.orders_insurances_attributes?.find(
      (item) => item.id === orderInsurance.id,
    ) || orderInsurance
  }

  const handleClaimFormCreate = async (orderInsurance) => {
    const patientInsurance = orderInsurance.patient_insurance_attributes
    const insuranceName = patientInsurance?.insurance_name
    const isRpaSupported = isRpaVerifiedInsurance(visionInsuranceConfig, services, insuranceName)
    const rpaVerificationFailed = isRpaVerificationFailed(visionInsuranceConfig, services, insuranceName)

    if (isRpaSupported || rpaVerificationFailed) {
      if (rpaVerificationFailed) {
        showInsuranceVerificationFailed(insuranceName)
        return
      }
      const insurance = getInsuranceFromRPAServices(services, insuranceName)
      await dispatch(visionInsuranceClaimFormCreate({
        add_ons_id: insurance.id,
        orders_order_id: order.id,
        orders_insurance_id: orderInsurance.id,
        patient_id: order.patient_id,
        insurance_type: patientInsurance?.insurance_type,
        store_id: order.store_id,
        insurance_payer: insuranceName,
        service: insurance.config.service,
        other_details: { resource: 'generate_claim' },
      }))
      await dispatch(visionInsuranceClaimFormLoad(order.id, { include: '*', orders_insurance_id: orderInsurance.id }))
      dispatch(visionInsuranceClaimFormEdit({ orders_insurance_id: orderInsurance.id }))
      const updatedInsurance = await refreshOrderInsurance(orderInsurance)
      await openClaimFormModal(updatedInsurance)
      return
    }

    await dispatch(claimFormCreate(order.id, { include: '*', orders_insurance_id: orderInsurance.id }))
    const updatedInsurance = await refreshOrderInsurance(orderInsurance)
    await openClaimFormModal(updatedInsurance)
  }

  const handleCreateClaimForm = (orderInsurance) => {
    if (order.insurance_receivable <= 0.0) {
      Alert.confirm('This order has a receivable less than or equal to $0 and creating a 1500 claim form could lead to a claim rejection.', (res) => {
        if (res) {
          handleClaimFormCreate(orderInsurance)
        }
      })
    } else {
      handleClaimFormCreate(orderInsurance)
    }
  }

  const handleViewClaimForm = (orderInsurance) => {
    const latestInsurance = ordersInsurances.find((item) => item.id === orderInsurance.id) || orderInsurance
    dispatch(visionInsuranceClaimFormEdit({ orders_insurance_id: latestInsurance.id }))
    openClaimFormModal(latestInsurance)
  }

  const renderInsuranceItem = (orderInsurance) => {
    const label = getInsuranceLabel(orderInsurance)
    const hasClaimForm = orderInsurance.claim_form_id || orderInsurance.visionary_insurance_claim_form_id

    return (
      <div key={orderInsurance.id} className="claim-form-dropdown__item">
        <span className="claim-form-dropdown__item-label">{label}</span>
        <button
          type="button"
          className={`claim-form-dropdown__action ${hasClaimForm ? 'claim-form-dropdown__action--view' : 'claim-form-dropdown__action--create'}`}
          onClick={() => hasClaimForm ? handleViewClaimForm(orderInsurance) : handleCreateClaimForm(orderInsurance)}
        >
          <i
            className={`la ${hasClaimForm ? 'la-eye' : 'la-file'} claim-form-dropdown__action-icon`}
            aria-hidden="true"
          />
          {hasClaimForm ? 'View Claim' : 'Create Claim'}
        </button>
      </div>
    )
  }

  const renderSection = (title, insurances) => {
    if (!insurances.length) {
      return null
    }

    return (
      <div className="claim-form-dropdown__section">
        <div className="claim-form-dropdown__section-header">{title}</div>
        {insurances.map(renderInsuranceItem)}
      </div>
    )
  }

  return (
    <div className="dropdown claim-form-dropdown d-inline-block mx-lg-3">
      <button
        className="btn btn-danger rounded-pill claim-form-dropdown__toggle dropdown-toggle"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        Claim Form
        {claimFormCount > 0 &&
          <span className="claim-form-dropdown__badge">{claimFormCount}</span>
        }
        <i className="ml-3 la la-angle-down la-sm" aria-hidden="true" />
      </button>
      <div className="dropdown-menu claim-form-dropdown__menu border-0 shadow py-0">
        {renderSection('Vision', visionInsurances)}
        {renderSection('Medical', medicalInsurances)}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { organisation: { organisation }, visionInsurance: { services } } = state
  return {
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
    services,
  }
}

export default connect(mapStateToProps)(ClaimFormDropdownButton)
